/**
 * Chiều cao TinyMCE theo tỉ lệ màn hình thiết bị.
 * @param {number} chromeOffset px chiếm bởi header/toolbar/tab ngoài editor
 */
export function getEditorViewportHeight(chromeOffset = 220) {
    if (typeof window === 'undefined') return 600;
    const h = Math.round(window.innerHeight - chromeOffset);
    return Math.max(320, Math.min(h, 1600));
}

/** CSS height — tự co giãn theo viewport, không cần remount */
export function getEditorViewportHeightCss(chromeOffset = 220) {
    return `max(320px, calc(100vh - ${chromeOffset}px))`;
}
